<template>
  <div class="answer-wrapper">
    <!--    @mouseleave="showPopup = false"-->
    <!--    @mouseenter="showPopup = true"-->
    <div
      class="-finished with adapting sc quest but haven't done yet need to add small fixes willfloating-wrapper-answers "
    >
      <div class="dropdown ">
        <div
          class="answer"
          :class="{ 'answer-for-sc': forSc }"
          @click="showMeno = !showMeno"
        >
          <!--{{ answers[0].answer.answer | truncate(8) }}-->

          <span
            class="answer-text"
            v-if="matchedAnswer() !== undefined"
            :class="{ closeAnswersOpt: showMeno, 'answer-text-for-sc': forSc }"
          >
            {{
              newAns != null
                ? newAns
                : !showMeno
                ? matchedAnswer().answer.answer
                : "close"
            }}</span
          ><span
            v-else
            :class="{
              closeAnswersOpt: showMeno,
              addForSc: forSc
            }"
            >{{
              tempAnsForNewAns != null ? tempAnsForNewAns : addOrClose
            }}</span
          >
        </div>

        <!--        class="answers-dropdown-menu"-->
        <ul
          class="assign-menu-item-answers"
          :class="{ 'assign-menu-item-answers-for-sc': forSc }"
          v-show="showMeno"
          @click="showMeno = !showMeno"
        >
          <input
            @click="showMeno = !showMeno"
            class="input-standard"
            type="search"
            placeholder="Search answer"
            v-model="answerQuery"
            @keyup="answerResults = filterFunction(answerQuery)"
          />
          <div class="dropdown-divider"></div>

          <div class="answer-menu-item re-checkbox" v-if="questionId === 1">
            <input
              type="checkbox"
              value="not chosen"
              id="re-checkbox"
              @change="
                clientRetired = $event.target.checked;
                updateRetired(clientRetired, client.id);
              "
              :checked="clientRetired"
            />
            <div
              @click="
                clientRetired = !clientRetired;
                updateRetired(clientRetired, client.id);
              "
              class="re-text"
              data-toggle="collapse"
              data-target="dropdown"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              Retired
            </div>
          </div>

          <div
            id="collapseOne"
            class="collapse"
            aria-labelledby="headingOne"
            data-parent="#accordion"
          >
            sustainable VHS.
          </div>

          <div class="dropdown-divider" v-if="questionId === 1"></div>
          <div v-if="answerResults.length > 0 && answerQuery.length > 0">
            <li
              @click="
                matchedAnswer() !== undefined
                  ? updateAnswer(matchedAnswer().id, answer.id, client.id)
                  : saveAnswer(answer.id, client.id)
              "
              class="answer-menu-item"
              v-for="answer in answerResults"
              :key="answer.id"
            >
              {{ answer.answer }}
            </li>
          </div>
          <div v-if="forSc">
            <div v-if="answerResults.length === 0 || answerQuery.length === 0">
              <li
                @click="
                  matchedAnswer() !== undefined
                    ? updateAnswer(
                        matchedAnswer().id,
                        answer.id,
                        client.id,
                        clientRetired
                      )
                    : saveAnswer(answer.id, client.id, clientRetired)
                "
                class="answer-menu-item"
                v-for="answer in clientAnswerOpt[questionId - 1].answers"
                :key="answer.id"
              >
                {{ answer.answer }}
              </li>
            </div>
          </div>
          <!--          <div v-if="!forSc">-->
          <!--            <div v-if="answerResults.length === 0 || answerQuery.length === 0">-->
          <!--              <li-->
          <!--                  @click="-->
          <!--                matchedAnswer() !== undefined-->
          <!--                  ? updateAnswer(-->
          <!--                      matchedAnswer().id,-->
          <!--                      answer.id,-->
          <!--                      client.id,-->
          <!--                      clientRetired-->
          <!--                    )-->
          <!--                  : saveAnswer(answer.id, client.id, clientRetired)-->
          <!--              "-->
          <!--                  class="answer-menu-item"-->
          <!--                  v-for="answer in dictionaries.general.client_questions[-->
          <!--                questionId - 1-->
          <!--              ].answers"-->
          <!--                  :key="answer.id"-->
          <!--              >-->
          <!--                {{ answer.answer }}-->
          <!--              </li>-->
          <!--            </div>-->
          <!--          </div>-->
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import ClickOutside from "v-click-outside";
import moment from "moment";
import { mapState } from "vuex";
import {
  setAnswer,
  updateAnswer,
  updateRetired
} from "../../api/clients_table.api";

export default {
  name: "ClientAnswer.component",

  props: {
    answKey: {
      type: Number
    },
    client: {
      type: Object,
      required: true
    },
    questionId: {
      type: Number,
      required: true
    },
    sendUpdated: {
      type: Boolean,
      default: () => false
    },
    clientAnswerOpt: {
      type: Object,
      required: true
    },
    forSc: {
      type: String
    }
    // root: {
    //   type: String
    // }
  },
  computed: {
    ...mapState("clients", ["dictionaries"])
  },
  directives: {
    clickOutside: ClickOutside.directive
  },
  data() {
    return {
      showPopup: false,
      matchedAns: {},
      showDropDown: false,
      answerQuery: "",
      answerResults: [],
      answeringBusy: false,
      numOfTruncate: 6,
      clientRetired: false,
      retiredBusy: false,
      showFloatBox: false,
      showMeno: false,
      addOrClose: "ADD",
      newAns: null,
      tempAnsForNewAns: null
    };
  },
  created() {
    // if (this.root === "depForm") {
    //   this.numOfTruncate = 30;
    // }
    // if (this.root === "depositTag") {
    //   this.numOfTruncate = 10;
    // }
    if (this.client.retired === 0) {
      this.clientRetired = false;
    }
    if (this.client.retired === 1) {
      this.clientRetired = true;
    }
    //this.matchedLog();
  },
  watch: {
    showMeno: function() {
      if (this.showMeno) {
        this.addOrClose = "CLOSE";
      } else if (!this.showMeno) {
        this.addOrClose = "ADD";
      }
    }
  },
  mounted() {
    // console.log(this.questionId,this.matchedAnswer().answer.answer);
  },
  methods: {
    formatDateTable(date) {
      return moment(String(date)).format("DD/MM/YY ");
    },

    matchedAnswer() {
      return this.client.answers.find(
        answer => answer.answer.question_id === this.questionId
      );
    },
    matchedLog() {
      return this.client.answers_log.filter(
        answer => answer.answer.question_id === this.questionId
      );
    },
    async saveAnswer(answerId, clientId) {
      if (this.answeringBusy === false) {
        this.answeringBusy = true;
        try {
          // this.$store.commit("clients/setLoading", true);

          let forSetAns = await setAnswer(answerId, clientId);
          // this.$store.commit("clients/setLoading", false);
          this.answerResults = [];
          this.answerQuery = "";
          const block = localStorage.getItem("lock-client");
          //this.$emit("unlock");

          await this.$emit("updated");
          this.showMeno = false;
          if (
            clientId === JSON.parse(block) &&
            this.client.answers.length > 8
          ) {
            //   alert()
            this.$emit("unlock");
          }
          /*          this.$store.commit("main/setShowVikiMsg", {
                            show: true,
                            msg: "Added New Answer",
                            type: "DONE"
                          });*/
          this.answeringBusy = false;
          this.tempAnsForNewAns = forSetAns.data.answer;
        } catch (e) {
          this.answerResults = [];
          this.answerQuery = "";
          // this.$store.commit("main/setShowVikiMsg", {
          //   show: true,
          //   msg:
          //     "Set Answer Error!" + " " + " Error Status: " + e.response.status,
          //   type: "ERROR"
          // });
          //
          // this.$store.commit("clients/setLoading", false);
        }
      }
    },
    async updateAnswer(itemId, answerId, clientId) {
      if (!this.answeringBusy) {
        this.answeringBusy = true;
        try {
          // this.$store.commit("clients/setLoading", true);
          let tempAns = await updateAnswer(itemId, answerId, clientId);
          this.answerResults = [];
          this.answerQuery = "";
          // this.$store.commit("clients/setLoading", false);
          // this.$store.commit("main/setShowVikiMsg", {
          //   show: true,
          //   msg: "Answer Updated",
          //   type: "DONE"
          // });
          await this.$emit("updated");
          this.componentKey += 1;
          this.answeringBusy = false;

          this.newAns = tempAns.data.answer.answer;
        } catch (e) {
          this.answerResults = [];
          this.answerQuery = "";
          // this.$store.commit("main/setShowVikiMsg", {
          //   show: true,
          //   msg:
          //     "Update/Change Answer Error!" +
          //     " " +
          //     " Error Status: " +
          //     e.response.status,
          //   type: "ERROR"
          // });
          // this.$store.commit("clients/setLoading", false);
        }
      }
    },

    async updateRetired(retired, clientId) {
      if (!this.retiredBusy) {
        this.retiredBusy = true;
        try {
          // this.$store.commit("clients/setLoading", true);
          await updateRetired(retired, clientId);
          // this.$store.commit("clients/setLoading", false);
          // this.$store.commit("main/setShowVikiMsg", {
          //   show: true,
          //   msg: "Client Retired Status Updated",
          //   type: "DONE"
          // });

          await this.$emit("updated");
          this.componentKey += 1;
          this.retiredBusy = false;
        } catch (e) {
          // this.$store.commit("main/setShowVikiMsg", {
          //   show: true,
          //   msg:
          //     "Update/Change Client Retired Status Error!" +
          //     " " +
          //     " Error Status: " +
          //     e.response.status,
          //   type: "ERROR"
          // });
          // this.$store.commit("clients/setLoading", false);
        }
      }
    },

    filterFunction(userInput) {
      return this.dictionaries.general.client_questions[
        this.questionId - 1
      ].answers.filter(function(broker) {
        userInput = userInput.trim();
        userInput = userInput.toLowerCase();
        let afterRegex = userInput.replace(/[.*+\-?^${}()|[\]\\]/g, "");
        return broker.answer.toLowerCase().includes(afterRegex);
      });
      // filterList(q) {
      //   function escapeRegExp(s) {
      //     return s.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
      //   }
      //
      //   const words = q
      //     .split(/\s+/g)
      //     .map(s => s.trim())
      //     .filter(s => !!s);
      //   const hasTrailingSpace = q.endsWith(" ");
      //   const searchRegex = new RegExp(
      //     words
      //       .map((word, i) => {
      //         if (i + 1 === words.length && !hasTrailingSpace) {
      //           return `(?=.*\\b${escapeRegExp(word)})`;
      //         } else {
      //           return `(?=.*\\b${escapeRegExp(word)}\\b)`;
      //         }
      //       })
      //       .join("") + ".+",
      //     "gi"
      //   );
      //   return this.dictionaries.general.client_questions[
      //     this.questionId - 1
      //   ].answers.filter(item => {
      //     return searchRegex.test(item.answer);
      //   });
    }
  }
};
</script>

<style scoped>
html * {
  font-family: "Montserrat" !important;
  /*  font-size: 10px;*/
  text-transform: uppercase;
}

.answer {
  cursor: pointer;
  text-align: center;
  font-size: 12px;
  margin-right: 34px;
}
.answer-for-sc {
  cursor: pointer;
  text-align: left;
  position: relative;
  font-size: 12px;
  left: 224px;
  font-family: "Montserrat" !important;
  /*margin-right:-249px;*/
}

.answer-wrapper {
  display: inline;
  position: relative;
  text-align: center;
}

.floating-wrapper-answers {
  position: relative;
}

.answer-table {
  position: absolute;
  top: 0px;
  right: 40px;
  height: 35px;
  z-index: 10001;
  width: max-content;
  background-color: #fff;
  border: solid 1px #4d4f50;
  border-radius: 5px;
  /*-webkit-box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0);*!*/
  /*-moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);*/
  /*box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);*/
}

.table-responsive {
  /*  margin-bottom: -20px;*/
  border-radius: 5px;
}

.td-answer {
  font-weight: 600;
  word-break: break-word;
  max-width: 250px;
}

.answers-dropdown {
  width: max-content;
}

.answers-dropdown-menu {
  border: solid 1px #90a4ae;
  border-radius: 0;
  /*  left: -60px;*/
  position: absolute;
  max-width: 50px !important;
  -webkit-box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0);
  /*-moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);*/
  background-color: white;
  /*box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);*/
  padding: 5px;
  height: auto;
  max-height: 500px;
  min-width: -webkit-max-content;
  min-width: -moz-max-content;
  min-width: max-content;
  overflow-x: hidden;
  text-align: left;
  z-index: 109;
  list-style-type: none;
}

.dropdown-menu {
  padding: 5px;
  height: auto;
  max-height: 500px;
  min-width: max-content;
  overflow-x: hidden;
  text-align: left;
}

.answer-menu-item {
  /*margin: 9px;*/
  font-size: 12px;
  text-transform: uppercase;
  padding: 7px;
}

.answer-menu-item:hover {
  background: #e0e0e0;
  cursor: pointer;
}

.answer-text {
  cursor: pointer;
  text-align: left;
  font-size: 14px;
}


.input-standard {
  width: 100%;
  position: relative;
  display: inline-block;
  padding: 4px 4px 4px 10px;
  /*border-radius: 5px;*/
  font-family: "Montserrat" !important;
  border-style: solid;
  border-color: lightgray;
  height: 30px;
  border-width: thin;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  font-size: 11px;
  box-sizing: border-box;
  outline: none;
}

.dropdown-divider {
  height: 1px;
  margin: 9px 0;
  overflow: hidden;
  background-color: #e5e5e5;
}
.txt-answer {
  font-weight: 800;
}
.txt-analogy {
  font-size: 11px;
}
.adddepform {
  color: #96281b;
}
.re-checkbox {
  display: flex;
  justify-content: left;
  align-items: center;
}
.re-text {
  /*
      font-size: 9px;
  */
  margin-left: 4px;
  margin-top: 4px;
  text-transform: uppercase;
}
.retired-row {
  display: flex;
  justify-content: center;
  font-weight: bold;
  font-size: 12px;
  text-align: center;
  background-color: #ebedee;
}
.dep-qs-form:nth-child(1) {
  margin-right: 50px;
}
.closeAnswersOpt {
  color: red;
}
.assign-menu-item-answers-for-sc {
  min-width: 250px !important;
  /* margin: 5px; */
  border-radius: 5px;
  font-size: 11px;
  text-transform: uppercase;
  text-align: left;
  position: fixed;
  width: 250px !important;
  right: -20px;
  left: 252px !important;
  right: 964px;
  padding: 7px;
  list-style-type: none;
  max-height: 301px;
  overflow-x: auto;
  margin-bottom: 0px;
  border: 1px solid lightgray;
  background-color: white;
  z-index: 1;
}
.assign-menu-item-answers {
  min-width: 278px;
  /* margin: 5px; */
  border-radius: 5px;
  font-size: 11px;
  text-transform: uppercase;
  text-align: left;
  position: fixed;
  /* right: -20px; */
  /* left: -7px; */
  right: 964px;
  padding: 7px;
  list-style-type: none;
  max-height: 301px;
  overflow-x: auto;
  margin-bottom: 0px;
  border: 1px solid lightgray;
  background-color: white;
  z-index: 1;
}
li.answer-menu-item:nth-child(even) {
  background-color: #f3f2f2;
}

li.answer-menu-item:nth-child(even):hover {
  background: lightgrey;
}
span.addForSc {
  position: relative;
  top: -18px;
  left: 46px;
  font-size: 14px;
}
.answer-text-for-sc {
  position: relative;
  top: -21px;
  left: 45px;

}
</style>
